import * as React from "react";
import { Modal, ModalSize, ModalBody, ModalFooter, ButtonType, CustomButton} from "soprasteria-ui-library/dist";
import { useAuth } from "../../App";


export const UnauthorizedModal: React.FunctionComponent<{}> = () => {
    const auth = useAuth();

    const onLoginClick = () => {
        document.getElementById("close-unauthorized-modal")?.click();
        auth.logout();
    }
    return (
        <Modal header="Obehörig" id="unauthorized-modal" modalSize={ModalSize.large}>
            <ModalBody>
                <p>Du saknar behörighet till it-systemet Menuett Portal.</p>
            </ModalBody>

            <ModalFooter>
                <input type="hidden" data-dismiss="modal" id="close-unauthorized-modal" data-target="#unauthorized-modal" />
                <CustomButton buttonType={ButtonType.createAlt} buttonText="Logga ut" data-dismiss="modal" onClick={onLoginClick} />
            </ModalFooter>
        </Modal>
    );
}